export const locale = {
    lang: "pt-BR",
    data: {
        TERMS_OF_USE: {
            TITLE: "Termos de Uso",
            DEFAULT: "Termos de uso não definidos.",
            SUBMIT_ERROR: "Erro ao recuperar termos de uso",
            BUTTON_LABEL: "Fechar"
        }
    }
};
